import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { GridColumn } from '@tkww/orion-web-ds-structure';
import React, { type FunctionComponent } from 'react';
import {
	CLICK_THROUGH_TO_CONTENT,
	clickThroughToContentBaseProps,
} from '../../../../utils/tracking';
import type { ArticleDetails } from '../types';
import { ArticlePicture } from './components/article_picture';
import { ArticleTitle } from './components/article_title';

import Styles from '../styles.scss';

interface Category {
	categoryCode: string;
	categoryName: string;
}

export interface Props {
	article: ArticleDetails;
	category: Category;
	categoryLink: string;
}

export const Article: FunctionComponent<Props> = (props: Props) => {
	const {
		article,
		category: { categoryCode, categoryName },
		categoryLink,
	} = props;
	const { track } = useAnalyticsContext();

	const trackClickThroughToContent = () => {
		track({
			event: CLICK_THROUGH_TO_CONTENT,
			properties: {
				contentTitle: article.title,
				vendorcategoryCode: categoryCode,
				...clickThroughToContentBaseProps,
			},
		});
	};

	return (
		<GridColumn xs="12" md="4" className={Styles.articleContainer}>
			<ArticlePicture
				article={article}
				trackClickThroughToContent={trackClickThroughToContent}
			/>
			<ArticleTitle
				article={article}
				categoryLink={categoryLink}
				categoryName={categoryName}
				trackClickThroughToContent={trackClickThroughToContent}
			/>
		</GridColumn>
	);
};
